import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit {

  user : any = {};
  errorMessage : string = '';
  error: boolean = false;
  loading : boolean = false;
  complete : boolean = false;

  constructor() { }

  ngOnInit() {
  }

  sendInstructions() {
    this.loading = true;
    firebase.auth().sendPasswordResetEmail(this.user.email)
      .then(response => {
        this.loading = false;
        this.complete = true;
      })
      .catch(error => {
        this.error = true;
        this.errorMessage = 'Comprueba tu dirección e intentalo de nuevo';
      })
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/signup/password-reset/password-reset.component.ts